export default __webpack_public_path__ + "static/media/competition-announcement.f5c6d753.md";